export type AiFlowEngine = "v1" | "v2"

export const AI_FLOW_ENGINE_OPTIONS: {
  value: AiFlowEngine
  label: string
  caption: string
}[] = [
  {
    value: "v2",
    label: "v2 — Tek ajan",
    caption:
      "Adım adım rehber: bir mesaj nasıl cevaplanır, kim neye karar verir"
  },
  {
    value: "v1",
    label: "v1 — Prompt zinciri",
    caption:
      "Platform, rol seçimi, Skills, intent, RAG, Action, stateful Commerce ve MCP akışı"
  }
]

export const V1_ENTRY_NODE_ID = "incoming-message"
